import { PDFViewer } from '@react-pdf/renderer'
import { useLocation } from 'react-router-dom'
import ProductPdfIndirectSales from '../../../features/Inventory/PuchaseOrderUI/ManageProduct/ProductPdfIndirectSales'

const ViewIndirectSales = () => {
    const location = useLocation()
    return (
        <div className=' w-full h-[900px]'>
            <PDFViewer width="100%" height="100%">
                <ProductPdfIndirectSales data={location.state.data} />
            </PDFViewer>
        </div>
    )
}


export default ViewIndirectSales
